__turbopack_context__.v({
  "content": "PXdM1W_content",
  "footer": "PXdM1W_footer",
  "mainContent": "PXdM1W_mainContent",
  "pageLoader": "PXdM1W_pageLoader",
  "wrapper": "PXdM1W_wrapper",
});
